import React, { Component } from 'react';
import {
  TextInput,
  Button,
  Loading,
  FormGroup,
  TextArea,
  TextInputSkeleton,
  DropdownSkeleton,
  DatePickerSkeleton
} from 'carbon-components-react';

import '../../scss/custom.scss';

import { switchDateFormat } from '../../helpers/jsonschemaform/customwidget/utils';
import { ComboBox } from '../../helpers/ComboBox';
import { showNotification } from '../../helpers/notification/BaseNotification';
import {
  getSuccess,
  getError,
  STATUS,
  entitiesLabels,
  apioperation,
  DateFormat
} from '../../helpers/Constants';
import { api, registry } from '../../helpers/api/api';
import SimpleReactValidator from 'simple-react-validator';
import { IsEditable, CanExecuteAction } from '../../helpers/authorization/Policies';
import { AppContext } from '../../helpers/context/AppContext';
import PageBreadCrumb from '../../helpers/PageBreadCrumb';
import { Information16 } from '@carbon/icons-react';
import { HistoryTable } from '../../helpers/HistoryTable';
import {CheckmarkOutline16} from '@carbon/icons-react/lib/';
import { WFActionModal } from '../common/WFActionModal';
import { v4 as uuid } from 'uuid';
import DateTimePicker from '../../helpers/DateTimePicker';
import AttachmentTable from '../common/AttachmentTable';
export default class CADetail extends Component {
  constructor(props) {
    super(props);
    this.validator = new SimpleReactValidator({ autoForceUpdate: this, locale: 'en' });
    let idIncidentEdit = props ? props.match.params.id : '';
    let idCar = props ? props.match.params.idCar : '';
    let idCa = props ? props.match.params.idCa : '';

    this.state = {
      idIncidentEdit: idIncidentEdit,
      idCar: idCar,
      idCa: idCa,
      isLoading: true,
      isSubmitted: false,
      model: null,
      keyCA: `formCA_${new Date().getTime()}`,
      appStatus: null,
      isDisabled: true,
      isHistoryModalOpen: false,
      ///Status Action
      isApprovalModalOpen: false,
      approvalModalAction: '',
      approver: null,
      approvalStartDate: null,
      approvalEndDate: null,
      isLoadingApproverOptions: true,
      approvalValidationMessages: [],
      approvers: [],
      selectedData: [],
      approverRole: '',
      withApprover: true,
      isLoadingWFOperation: false,
      approvalNotesRequired: false,
      ///Status Action
    };
    this.baseUrl = '/incident/' + idIncidentEdit + '/car/' + idCar + '/ca/' + idCa + '/detail';
  }

  baseUrl;

  componentDidMount() {
    this.getCA();
    this.getStatus();
  }
  showButtonHistory = () => {
    return (
      <Button
        className="action-button-modal"
        kind="secondary"
        renderIcon={Information16}
        onClick={() => this.openModalHistory()}
      >
        History
      </Button>
    );
  };
  openModalHistory = () => {
    this.setState({ isHistoryModalOpen: true });
  };
  closeModalHistory = () => {
    this.setState({ isHistoryModalOpen: false });
  };
  getStatus = () => {
    registry
      .getAll('status')
      .then((response) => {
        var data = response.data;
        //data = data != null ? data.filter(item => (item.id == 1 || item.id == 4)) : [];
        this.setState({
          appStatus: data,
        });
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.STATUS, apioperation.GET)
        );
      })
      .finally(() => {});
  };

  getCA = () => {
    this.setState({
      isLoading: true,
    });

    api
      .getAll(this.baseUrl)
      .then((response) => {
        let data = response.data;
        if (data) {
          this.setState({
            model: data,
          });
        } else {
          showNotification.error();
        }
      })
      .catch((error) => {
        showNotification.error(
          `${entitiesLabels.ERROR}`,
          getError(error, entitiesLabels.CA, apioperation.GET)
        );
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        });
      });
  };

  showLoading() {
    let show = this.state.isLoading || this.state.isSubmitted;
    let descr = this.state.isSubmitted ? 'Saving...' : 'Loading data...';
    return show && <Loading active={true} withOverlay={true} description={descr} />;
    //return (<InlineLoading className="bx--loading-overlay" {...props} />)
  }

  updateState = (inputName, inputValue, objName) => {
    let statusCopy = Object.assign({}, this.state.model);
    if (objName && objName != 'model') statusCopy[objName][inputName] = inputValue;
    else statusCopy[inputName] = inputValue;

    this.setState({ model: statusCopy });
  };

  saveCA = () => {
    if (this.validator.allValid()) {
      let datiForm = this.state.model;
      if (!datiForm) return;

      this.setState({
        isSubmitted: true,
      });

      api
        .put(this.baseUrl, datiForm)
        .then((response) => {
          if (response.status == 200) {
            showNotification.success(
              `${entitiesLabels.SUCCESS}`,
              getSuccess(entitiesLabels.CA, apioperation.PUT)
            );
            this.getCA();
          } else {
            showNotification.error();
          }
        })
        .catch((error) => {
          showNotification.error(`${entitiesLabels.ERROR}`, getError(error, 'CA', 'PUT'));
        })
        .finally(() => {
          this.setState({
            isSubmitted: false,
          });
        });
    } else {
      this.validator.showMessages();
      showNotification.warning(
        `${entitiesLabels.WARNING}`,
        `${entitiesLabels.INCIDENT} field not valid`
      );
      this.forceUpdate();
    }
  };

  cancel = () => {
    if (this.props.history.length == 1) console.log('TODO, Chiudere la pagina???');
    else this.props.history.goBack();
  };

  handleApproverSelect = (selectedItem) => {
    this.setState({ approver: selectedItem });
  };

  handleCloseApprovalModal = () => {
    this.setState({ isApprovalModalOpen: false }, this.clearApprovalForm);
  };

  handleApprovalNotesChange = (e) => {
    this.setState({ approvalNotes: e.target.value });
  };

  handleConfirmApprovalModal = () => {
  
    //let action = this.state.approvalModalAction.toLowerCase();
    let apiEndpoint = this.state.approvalEndpoint;

    //ALESSANDRO DI PIETRO 27/08/2021 RITM0508028
      //if (action.toLowerCase() === "close") {
      //    this.saveCA();
      //}
    //ALESSANDRO DI PIETRO 27/08/2021 RITM0508028


    const data = {
      ids: [this.state.idCa],
      owner: this.state.approver,
      workflowNotes: this.state.approvalNotes,
    };

    this.setState({
      isLoadingWFOperation: true,
    });
    api
      .put(
        '/incident/' +
          this.state.idIncidentEdit +
          '/car/' +
          this.state.idCar +
          '/ca/' +
          apiEndpoint,
        data,
        ''
      )
      .then((response) => {
        if (response.status === 200) {
          showNotification.success(
            `${entitiesLabels.SUCCESS}`,
            getSuccess(entitiesLabels.CA, apioperation.PUT)
          );
          this.setState({
            isLoadingWFOperation: false,
            isApprovalModalOpen: false,
            isLoading: true,
             model: null
          });
          this.getCA();
        } else {
            showNotification.error();
            this.setState({
                isLoadingWFOperation: false,
            });
        }

      })
        .catch((error) => {
            if (error.response.status === 406) {
                showNotification.warning(`${entitiesLabels.WARNING}`, 'Required CA fields was not saved. Use the save button before closing CA');
            } else {
                showNotification.error(
                    `${entitiesLabels.ERROR}`,
                    getError(error, entitiesLabels.CA, apioperation.PUT)
                );
            }
            this.setState({
              isLoadingWFOperation: false,
            });
      })
      .finally(() => {});
  };

  IsRowSelectable() {
    var row = this.state.model;
    if (row == null) return false;

    return true;
  }

  batchActionClick(
    actionKey,
    actionName,
    approverRole,
    withApprover,
    approvalNotesRequired,
    selectedRows
  ) {
    if (this.validator.allValid()) {
      this.setState({
        approvalModalAction: actionName,
        isApprovalModalOpen: true,
        isLoadingApproverOptions: true,
        withApprover: withApprover,
        selectedData: selectedRows,
        approverRole: approverRole,
        approvalEndpoint: actionKey,
        approvalNotesRequired: approvalNotesRequired,
      });
    } else {
      this.validator.showMessages();
      showNotification.warning(`${entitiesLabels.WARNING}`, ' field not valid');
      this.forceUpdate();
    }
  }
  ///ATTACHMENTS
  clearAttachment = () => ({
    id: null, // guid
    fileIdentifier: null,
    name: null,
    contentType: null,
    size: null,
    type: null,
  });
  remove = (id) => {
    if (!id) return;

    let statusCopy = Object.assign({}, this.state.model);
    statusCopy.attachment = statusCopy.attachment.filter((el) => el.id !== id);

    this.setState({
      model: statusCopy,
    });
  };
  onUpload = (fileIdentifier, fileName, fileType, size) => {
    const attachment = { ...this.state.attachment };

    attachment.id = uuid();
    attachment.fileIdentifier = fileIdentifier.blobName;
    attachment.name = fileName;
    attachment.contentType = fileType;
    attachment.size = size;
    // attachment.filePath = file.localPath;

    this.setState({
      attachment: this.clearAttachment(),
    });

    try {
      if (attachment == null) return;
      //insert
      let oldattachment = this.state.model.attachment || [];

      let newItem = {
        id: uuid(), //guid
        // idIncident: this.props.incidentEditModel.id,
        idAttachment: attachment.id, //guid
        attachment: attachment,
      };

      let newattachment = oldattachment.concat([newItem]);
      this.updateState('attachment', newattachment, 'model');
    } catch (error) {
      showNotification.error();
    }
  };
  getStatusActions = (user) => {
    if (!this.IsRowSelectable()) return null;

    const canEditResource = this.state.model && {
      email:
        this.state.model.incidentCAR.owner != null
          ? this.state.model.incidentCAR.owner.email
          : this.state.model.incidentCAR.ownerSaipem.email,
      idCompiler: this.state.model.idIncidentCompiler,
    };

    const idStatus = this.state.model.idStatus;
    return (
      <>
        {CanExecuteAction('Incident', 'CAManagement', user, idStatus, 'Close', canEditResource) ? (
          <Button
            renderIcon={CheckmarkOutline16}
            disabled={!this.state.model.immediateThreatment}
            onClick={() => this.batchActionClick('Close', 'Close', null, false, false, null)}
          >
            Close CA
          </Button>
        ) : null}

        {CanExecuteAction('Incident', 'CAManagement', user, idStatus, 'Open', canEditResource) ? (
          <Button
            renderIcon={CheckmarkOutline16}
            onClick={() => this.batchActionClick('Open', 'Open', null, false, false, null)}
          >
            Open CA
          </Button>
        ) : null}
      </>
    );
  };

  render() {
    const validations = {
      immediateThreatment: this.state.model
        ? this.validator.message(
            'immediateThreatment',
            this.state.model.immediateThreatment,
            'required'
          )
        : null,
    };

    const selectedItemCombo = {
      idStatus: this.state.model
        ? (this.state.appStatus || []).find(
            (el) =>
              el.id == (this.state.model.isClose ? STATUS.Consolidated : this.state.model.idStatus)
          )
        : null,
      appStatus: (this.state.appStatus || []).filter(
        (el) => el.id == STATUS.Submitted || el.id == STATUS.Consolidated
      ),
    };

    const owner = this.state.model && this.state.model.owner;
    
    return (
      <AppContext.Consumer>
        {({ user }) => (
          <>
            <PageBreadCrumb
              linkTo={'/incident/' + this.state.idIncidentEdit + '/car/' + this.state.idCar}
              linkText="CAR Detail"
              titleLeft={
                'Incident Id: ' +
                ((this.state.model && this.state.model.incidentCode) || '') +
                ' - CA Detail'
              }
              titleCenter={this.state.model && 'ID: ' + this.state.model.incidentCACode}
              titleRight={
                this.state.model && this.state.model.status
                  ? this.state.model.status.caManagementName
                  : null
              }
              batchActions={this.getStatusActions(user)}
              showButtonHistory={this.showButtonHistory()}
            />

            <div className="mainContainer">
              {this.showLoading()}
              <WFActionModal
                show={this.state.isApprovalModalOpen}
                title={`${this.state.approvalModalAction} Incident CAs`}
                action={this.state.approvalModalAction}
                withApprover={this.state.withApprover}
                approver={this.state.approver}
                approverRole={this.state.approverRole}
                approverOptions={this.state.approvers}
                isLoadingOperation={this.state.isLoadingWFOperation}
                onApproverSelect={this.handleApproverSelect}
                isLoadingOptions={this.state.isLoadingApproverOptions}
                onCancel={this.handleCloseApprovalModal}
                onConfirm={this.handleConfirmApprovalModal}
                onApprovalNotesChange={this.handleApprovalNotesChange}
                approvalNotes={this.state.approvalNotes}
                approvalNotesRequired={this.state.approvalNotesRequired}
                validationMessages={this.state.approvalValidationMessages}
              />
              {
                <HistoryTable
                  entityId={this.state.idCa}
                  isOpenModal={this.state.isHistoryModalOpen}
                  onClose={() => this.closeModalHistory()}
                />
              }
              <div className="bx--row">
                <div className="bx--col-lg-12 bx--col-md-12">
                  <div className="bx--row">
                    <div className="bx--col-lg-12">
                      <div className="bx--grid--full-width">
                        <div className="bx--row">
                          <div className="bx--col--md-12 bx--col-lg-12">
                            <FormGroup legendText="Corrective action to be implemented">
                              {!this.state.model ? (
                                <TextInputSkeleton hideLabel />
                              ) : (
                                <TextArea
                                  maxLength={5000}
                                  id="caImplemented"
                                  placeholder="Input Corrective action"
                                  value={this.state.model.caImplemented || ''}
                                  onChange={(el) =>
                                    this.updateState('caImplemented', el.target.value, 'model')
                                  }
                                  hideLabel={true}
                                  labelText=""
                                  light
                                  rows={4}
                                  cols={225}
                                  className="disable-text"
                                  disabled={true}
                                />
                              )}
                            </FormGroup>
                          </div>
                          <div className="bx--col--md-4 bx--col-lg-6">
                            <FormGroup legendText="Direct Cause Category">
                              {!this.state.model ? (
                                <TextInputSkeleton hideLabel />
                              ) : (
                                <TextInput
                                  id="txt-directCause"
                                  type="text"
                                  labelText=""
                                  className="bx--text-input disable-text"
                                  value={this.state.model.directCause || ''}
                                  disabled={true}
                                />
                              )}
                            </FormGroup>
                          </div>
                          <div className="bx--col--md-4 bx--col-lg-6">
                            <FormGroup legendText="Direct Cause Sub-Category">
                              {!this.state.model ? (
                                <TextInputSkeleton hideLabel />
                              ) : (
                                <TextInput
                                  id="txt-directCauseSub"
                                  type="text"
                                  labelText=""
                                  className="bx--text-input disable-text"
                                  value={this.state.model.directCauseSubCategory || ''}
                                  disabled={true}
                                />
                              )}
                            </FormGroup>
                          </div>
                          <div className="bx--col--md-4 bx--col-lg-6">
                            <FormGroup legendText="Root Cause Category">
                              {!this.state.model ? (
                                <TextInputSkeleton hideLabel />
                              ) : (
                                <TextInput
                                  id="txt-rootCause"
                                  type="text"
                                  labelText=""
                                  className="bx--text-input disable-text"
                                  value={this.state.model.rootCause || ''}
                                  disabled={true}
                                />
                              )}
                            </FormGroup>
                          </div>
                          <div className="bx--col--md-4 bx--col-lg-6">
                            <FormGroup legendText="Root Cause Sub-Category">
                              {!this.state.model ? (
                                <TextInputSkeleton hideLabel />
                              ) : (
                                <TextInput
                                  id="txt-rootCauseSub"
                                  type="text"
                                  labelText=""
                                  className="bx--text-input disable-text"
                                  value={this.state.model.rootCauseSubCategory || ''}
                                  disabled={true}
                                />
                              )}
                            </FormGroup>
                          </div>
                          <div className="bx--col--md-4 bx--col-lg-6">
                            <FormGroup legendText="Root Cause Sub-Category Detail">
                              {!this.state.model ? (
                                <TextInputSkeleton hideLabel />
                              ) : (
                                <TextInput
                                  id="txt-rootCauseSubD"
                                  type="text"
                                  labelText=""
                                  className="bx--text-input disable-text"
                                  value={this.state.model.rootCauseSubCategoryDetail || ''}
                                  disabled={true}
                                />
                              )}
                            </FormGroup>
                          </div>
                          <div className="bx--col--md-4 bx--col-lg-6">
                            <FormGroup legendText="Type">
                              {!owner ? (
                                <TextInputSkeleton hideLabel />
                              ) : (
                                <TextInput
                                  id="txt-type"
                                  type="text"
                                  labelText=""
                                  className="bx--text-input disable-text"
                                  value={this.state.model.owner.type || ''}
                                  disabled={true}
                                />
                              )}
                            </FormGroup>
                          </div>
                          <div className="bx--col--md-4 bx--col-lg-6">
                            <FormGroup legendText="CA Owner">
                              {!owner ? (
                                <TextInputSkeleton hideLabel />
                              ) : (
                                <TextInput
                                  id="txt-fullname"
                                  type="text"
                                  labelText=""
                                  className="bx--text-input disable-text"
                                  value={this.state.model.owner.fullname || ''}
                                  disabled={true}
                                />
                              )}
                            </FormGroup>
                          </div>
                          <div className="bx--col--md-4 bx--col-lg-6">
                            <FormGroup legendText="Due Date">
                              {!this.state.model ? (
                                <TextInputSkeleton hideLabel />
                              ) : (
                                <TextInput
                                  id="txt-dueDate"
                                  type="text"
                                  labelText=""
                                  className="bx--text-input disable-text"
                                  value={switchDateFormat(this.state.model.dueDate, 'date')}
                                  disabled={true}
                                />
                              )}
                            </FormGroup>
                          </div>
                          <div className="bx--col--md-4 bx--col-lg-6">
                            <FormGroup legendText="Due Date Change Notes">
                              {!this.state.model ? (
                                <TextInputSkeleton hideLabel />
                              ) : (
                                <TextInput
                                  id="txt-dueDateChangeNotes"
                                  type="text"
                                  labelText=""
                                  className="bx--text-input disable-text"
                                  value={this.state.model.dueDateChangeNotes || ''}
                                  disabled={true}
                                />
                              )}
                            </FormGroup>
                          </div>
                          <div className="bx--col--md-4 bx--col-lg-6">
                            <FormGroup legendText="Status*">
                              {!this.state.model ? (
                                <TextInputSkeleton hideLabel />
                              ) : IsEditable(
                                  'Incident',
                                  'CAManagement',
                                  user,
                                  this.state.model.idStatus,
                                  'Status',
                                  {
                                    email: this.state.model.owner.email,
                                    idCompiler: this.state.model.idIncidentCompiler,
                                  }
                                ) ? (
                                this.state.appStatus == null ? (
                                  <DropdownSkeleton />
                                ) : (
                                  <ComboBox
                                    id="isClose"
                                    placeholder="Select"
                                    name="isClose"
                                    alt="model"
                                    onChange={(name, val, alt) =>
                                      this.updateState(
                                        'isClose',
                                        val && val.id == STATUS.Consolidated ? true : false,
                                        'model'
                                      )
                                    }
                                    itemToString={(item) => (item ? item.caManagementName : '')}
                                    initialSelectedItem={selectedItemCombo.idStatus}
                                    items={selectedItemCombo.appStatus}
                                  />
                                )
                              ) : (
                                <TextInput
                                  id="txt-status"
                                  type="text"
                                  labelText=""
                                  className="bx--text-input disable-text"
                                  value={
                                    this.state.model.status &&
                                    this.state.model.status.caManagementName
                                  }
                                  disabled={true}
                                />
                              )}
                            </FormGroup>
                          </div>

                          <div className="bx--col-md-6 bx--col-lg-6">
                            <FormGroup legendText="Actual date of completion of CA">
                              {!this.state.model ? (
                                <TextInputSkeleton hideLabel />
                              ) : (
                                <div className="bx--col-md-6 bx--col-lg-6 pl-0">
                                  {!this.state.model ? (
                                    <DatePickerSkeleton />
                                  ) : (
                                    <DateTimePicker
                                      value={this.state.model?.actualDateCompletition}
                                      type="date"
                                      disableFutureDate
                                      placeholder={DateFormat}
                                      name="actualDateCompletition"
                                      alt="model"
                                      id="actualDateCompletition"
                                      onChange={this.updateState}
                                      disabled={!IsEditable(
                                        'Incident',
                                        'CAManagement',
                                        user,
                                        this.state.model?.idStatus,
                                        'Status',
                                        {
                                          email: this.state.model?.owner.email,
                                          idCompiler: this.state.model?.idIncidentCompiler,
                                        }
                                      ) }
                                    />
                                )}
                              </div>
                              )}
                            </FormGroup>
                          </div>


                          <div className="bx--col--md-12 bx--col-lg-12">
                            <FormGroup legendText="Evidence of Corrective Action*">
                              {!this.state.model ? (
                                <TextInputSkeleton hideLabel />
                              ) : (
                                <TextArea
                                  maxLength={5000}
                                  id="immediateThreatment"
                                  value={this.state.model.immediateThreatment || ''}
                                  onChange={(el) =>
                                    this.updateState(
                                      'immediateThreatment',
                                      el.target.value,
                                      'model'
                                    )
                                  }
                                  hideLabel={true}
                                  labelText=""
                                  light
                                  rows={4}
                                  cols={225}
                                  invalid={validations.immediateThreatment != null}
                                  disabled={
                                    !IsEditable(
                                      'Incident',
                                      'CAManagement',
                                      user,
                                      this.state.model.idStatus,
                                      'ImmediateThreatment',
                                      {
                                        email: this.state.model.owner.email,
                                        idCompiler: this.state.model.idIncidentCompiler,
                                      }
                                    )
                                  }
                                />
                              )}
                              {validations.immediateThreatment}
                            </FormGroup>
                          </div>
                          {/* DEV 383 */}
                            <AttachmentTable
																storagePath="Incident"
																model={this.state.model}
																items={this.state.model?.attachment}
																apiDownloadUrl={`/incident/${this.state.idIncidentEdit}/car/${this.state.idCar}/ca/${this.state.idCa}/attachment/`}
																onUploadFIle={this.onUpload}
																onDeleteFile={this.remove}
																isDisabled={ !IsEditable(
                                  'Incident',
                                  'CAManagement',
                                  user,
                                  this.state.model?.idStatus,
                                  'ImmediateThreatment',
                                  {
                                    email: this.state.model?.owner.email,
                                    idCompiler: this.state.model?.idIncidentCompiler,
                                  }
                                ) }
															/> 
                          {/* DEV 383 */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bx--row table-culumn-actions">
                    <Button
                      onClick={() => this.cancel()}
                      className="bx--col bx--btn--max-width"
                      size="default"
                      kind="secondary"
                    >
                      Cancel
                    </Button>
                    <Button
                      onClick={() => this.saveCA()}
                      disabled={
                        owner
                          ? !IsEditable(
                              'Incident',
                              'CAManagement',
                              user,
                              this.state.model.idStatus,
                              'ImmediateThreatment',
                              {
                                email: this.state.model.owner.email,
                                idCompiler: this.state.model.idIncidentCompiler,
                              }
                            )
                          : true
                      }
                      className="bx--col bx--btn--max-width"
                      size="default"
                      kind="primary"
                    >
                      Save
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </AppContext.Consumer>
    );
  }
}
